import axiosIns from '@/plugins/axios'

export default {
  getVendibles() {
    return axiosIns.get('/waiter/vendibles')
  },
}
